import { Injectable, inject } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/compat/functions';

import { firstValueFrom } from 'rxjs';

import { PartnerImportOption, PartnerImportResult } from 'src/app/models/partner-played.model';

/** The voter-facing partner import (functions/src/partner-import.ts). */
@Injectable({ providedIn: 'root' })
export class PartnerImportService {
  private functions = inject(AngularFireFunctions);

  private options: Promise<PartnerImportOption[]> | null = null;

  /** The partners to offer, live or coming soon; fetched once per page load. */
  async loadOptions(): Promise<PartnerImportOption[]> {
    this.options ??= firstValueFrom(
        this.functions.httpsCallable<Record<string, never>, PartnerImportOption[]>('listPartnerImports')({}))
      .catch((error: unknown) => {
        this.options = null;  // let a later call retry
        throw error;
      });
    return this.options;
  }

  /** Imports the voter's played rooms from one partner. `userid` is only for sandbox mock partners. */
  async importRooms(partnerId: string, userid?: string): Promise<PartnerImportResult> {
    return firstValueFrom(
        this.functions.httpsCallable<{ partnerId: string; userid?: string }, PartnerImportResult>(
            'importPartnerPlayedRooms')({ partnerId, ...(userid !== undefined ? { userid } : {}) }));
  }
}
